module.exports = require('./lib/ObjectPath.js').ObjectPath;



//////////////////
// WEBPACK FOOTER
// ./~/objectpath/index.js
// module id = 1961
// module chunks = 1